module.exports = __webpack_public_path__ + "static/media/OutliersQ7_1.e6f0fada.svg";